import { Injectable } from '@angular/core';
import { ServerConnectionService } from './server-connection.service';
import { CoreModule } from '../core.module';
import { IChangeRequestFormBody, IContactFormBody } from '../../types/datatypes';

@Injectable({
	providedIn: CoreModule,
})
export class FrontService {
	constructor(
		private scs: ServerConnectionService,
	) { }

	sendContactForm(body: IContactFormBody) {
		return new Promise((resolve, reject) => {
			this.scs.http$('POST', '/api/front/contact-message', null, body).subscribe((result: any) => {
				if (!result.success) {
					reject(result.message);
				} else {
					resolve(result.generatedDescription);
				}
			});
		});
	}

	sendChangeRequest(body: IChangeRequestFormBody) {
		return new Promise((resolve, reject) => {
			this.scs.http$('POST', '/api/front/change-request', null, body).subscribe((result: any) => {
				if (!result.success) {
					reject(result.message);
				} else {
					resolve('');
				}
			});
		});
	}
}
